// Laravel endpoints in this project may return an array directly, wrap it in
// { data: [] }, or return a paginated { data: { data: [] } } payload.
// List screens must always receive an array so rendering with map/forEach is safe.
export const asArray = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

